import { Link } from "react-router-dom";
import type { ReactNode } from "react";

export const HEADER_BACK_LINK_CLASS =
  "inline-flex items-center gap-1.5 min-h-[44px] px-2 py-1 border-0 bg-transparent rounded-[var(--radius-md)] cursor-pointer " +
  "text-sm font-[var(--font-display)] font-semibold uppercase tracking-wider text-[var(--color-signal-blue)] " +
  "hover:text-[var(--color-highlight-blue)] hover:underline underline-offset-2 " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-signal-blue)] focus-visible:ring-offset-2 " +
  "focus-visible:ring-offset-[var(--color-charcoal)]";

function ChevronLeft({ className = "w-4 h-4 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  );
}

export type HeaderBackLinkProps = {
  /** Use router navigation (e.g. back to list). */
  to?: string;
  /** In-app back when `to` is omitted. */
  onClick?: () => void;
  children?: ReactNode;
  className?: string;
  showChevron?: boolean;
};

/**
 * Text-style back control for headers and page tops — not a filled `Button`.
 */
export function HeaderBackLink({
  to,
  onClick,
  children = "Back",
  className = "",
  showChevron = true,
}: HeaderBackLinkProps) {
  const merged = `${HEADER_BACK_LINK_CLASS}${className ? ` ${className}` : ""}`;
  const inner = (
    <>
      {showChevron ? <ChevronLeft /> : null}
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={merged}>
        {inner}
      </Link>
    );
  }

  return (
    <button type="button" className={merged} onClick={onClick}>
      {inner}
    </button>
  );
}
